module.exports = __webpack_public_path__ + "static/media/s_22.43d3ce87.mp3";